import { shouldLog } from "./utils";
export const createSimpleLogger = (prefix) => ({
    log: (...rest) => {
        if (!shouldLog()) {
            return;
        }
        try {
            console.log(`[${prefix}]`, ...rest);
        }
        catch (e) {
            console.error(e);
        }
    },
});
